export default "__VITE_ASSET__CRkohhzm__"